module.exports = __webpack_public_path__ + "static/media/cyuce013.5e17bd2c.jpg";